import { useState } from 'react';
import { useNavigate } from 'react-router';
import { DropdownMenu } from 'radix-ui';
import { CircleUserRound, Lock, LogOut, Type } from 'lucide-react';
import { useMe } from '../../hooks/useMe';
import { useSignOut } from '../../hooks/useSignOut';
import { DisplaySettingsDialog } from './DisplaySettings';
import { menuContentClass, menuItemClass } from './menuStyles';

/** Account menu: security settings, display settings and sign out. */
export function UserMenu({ wsId }: { wsId?: string }) {
  const me = useMe();
  const navigate = useNavigate();
  const { signOut } = useSignOut();
  const [displayOpen, setDisplayOpen] = useState(false);
  const user = me.data?.user;
  const securityPath = wsId ? `/w/${wsId}/more/security` : '/account/security';

  return (
    <>
      <DropdownMenu.Root modal={false}>
        <DropdownMenu.Trigger
          className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-text hover:bg-surface-muted"
          aria-label="Your account"
        >
          <CircleUserRound aria-hidden="true" className="h-7 w-7" />
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content align="end" sideOffset={6} className={menuContentClass}>
            {user && (
              <DropdownMenu.Label className="px-3 py-2">
                <span className="block font-bold">{user.name ?? 'Signed in'}</span>
                <span className="block text-sm break-all text-muted">{user.email}</span>
              </DropdownMenu.Label>
            )}
            <DropdownMenu.Separator className="my-1 h-px bg-border" />
            <DropdownMenu.Item className={menuItemClass} onSelect={() => navigate(securityPath)}>
              <Lock aria-hidden="true" className="h-5 w-5" />
              Account security
            </DropdownMenu.Item>
            <DropdownMenu.Item className={menuItemClass} onSelect={() => setDisplayOpen(true)}>
              <Type aria-hidden="true" className="h-5 w-5" />
              Text size and colours
            </DropdownMenu.Item>
            <DropdownMenu.Separator className="my-1 h-px bg-border" />
            <DropdownMenu.Item className={menuItemClass} onSelect={() => void signOut()}>
              <LogOut aria-hidden="true" className="h-5 w-5" />
              Sign out
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
      <DisplaySettingsDialog open={displayOpen} onOpenChange={setDisplayOpen} />
    </>
  );
}
